import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import { Link } from "react-router-dom";
import "./styles.css";

const SettingsUserGroups = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [joinedGroups, setJoinedGroups] = useState([]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (user) {
        fetchUserGroups(user.uid);
      } else {
        setJoinedGroups([]);
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchUserGroups = async (uid) => {
    try {
      const database = getDatabase();
      const userGroupsRef = ref(database, `USERS/${uid}/GROUPS`);
      const snapshot = await get(userGroupsRef);

      if (snapshot.exists()) {
        const groupsData = snapshot.val();
        const groupsList = [];

        // Convert nested structure to flat array
        for (const groupId in groupsData) {
          for (const slugKey in groupsData[groupId]) {
            groupsList.push({
              groupId,
              ...groupsData[groupId][slugKey],
            });
          }
        }

        setJoinedGroups(groupsList);
      } else {
        setJoinedGroups([]);
      }
    } catch (error) {
      console.error("Error fetching user groups:", error);
      setJoinedGroups([]);
    }
  };

  // Don't render if not logged in or no groups
  if (!currentUser || joinedGroups.length === 0) {
    return (
      <div className="settings-groups-container">
        <h5 className="card-title mb-1">Your Groups</h5>
        <p className="card-text mb-4 text-gray-500">
          You haven't joined any groups yet.
        </p>
      </div>
    );
  }

  return (
    <div className="settings-groups-container">
      <h5 className="card-title mb-1">Your Groups</h5>
      <p className="card-text mb-4 text-gray-500">
        Groups you've joined ({joinedGroups.length})
      </p>

      <div className="settings-groups-list">
        {joinedGroups.map((group) => (
          <Link
            to={`/Group/${group.GROUP_SLUG}`}
            key={`${group.groupId}-${group.GROUP_SLUG}`}
            className="settings-group-item"
          >
            <div className="settings-group-info">
              <h6 className="settings-group-name">{group.GROUP_NAME}</h6>
              <p className="settings-group-meta">
                <span className="settings-group-rank">
                  {group.GROUP_RANK === "OWNER"
                    ? "Owner"
                    : group.GROUP_RANK === "ADMIN"
                    ? "Admin"
                    : "Member"}
                </span>
                <span className="settings-group-date">
                  Joined {group.JOINED_DATE}
                </span>
              </p>
            </div>
            <div className="settings-group-arrow">
              <i className="bi bi-chevron-right"></i>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SettingsUserGroups;
